module.exports = "/_next/static/images/num-2-98a92e33.png";